
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 18l-.8-.716a106.393 106.393 0 01-1.989-1.816 24.502 24.502 0 01-1.394-1.458c-.5-.58-.844-1.1-1.033-1.56a3.923 3.923 0 01-.284-1.458c0-.835.284-1.543.852-2.122.585-.58 1.308-.87 2.17-.87.998 0 1.824.384 2.478 1.15.654-.766 1.48-1.15 2.479-1.15.86 0 1.575.29 2.143.87.585.58.878 1.287.878 2.122 0 .665-.224 1.356-.671 2.072a10.27 10.27 0 01-1.472 1.867c-.517.529-1.369 1.321-2.556 2.379L13 18z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.631 2.427A1.897 1.897 0 009.43 2c-.441 0-.868.151-1.203.427L2.654 7c-.205.168-.37.377-.482.613A1.742 1.742 0 002 8.366v7.151c0 .366.15.717.418.976.268.258.632.404 1.01.404h5.455a31.327 31.327 0 01-1.379-1.476l-.005-.006-.006-.006c-.603-.707-1.067-1.395-1.337-2.059l-.005-.012a5.53 5.53 0 01-.391-2.035c0-1.208.417-2.27 1.249-3.128l.005-.006.005-.005c.86-.86 1.939-1.289 3.168-1.289 1.068 0 2.015.319 2.813.936.798-.617 1.745-.936 2.813-.936.082 0 .164.002.245.006L10.63 2.427z","fill":"currentColor"}})])
          )
        }
      }
    